module.exports = __webpack_public_path__ + "images/emoji/large_orange_diamond.bfaf6c78bccc26c71d27.png";